import React, { useEffect, useState } from "react";
import FormInputLoader from "../FormInputLoader/FormInputLoader";
import { Select } from "@instructure/ui-select";
import { TimeOptions } from "../../utils/timeOptions";

const IasFormTimeInput = ({
  isLoading,
  id,
  name,
  renderLabel,
  value,
  dropdownDataError,
  onChange,
  reset
}) => {
  const [showingOptions, setShowingOptions] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);
  const [highlightOptionId, setHighlightOptionId] = useState(value);
  const hanldeRequestShowOption = () => {
    setShowingOptions((showingOptions) => !showingOptions);
  };

  useEffect(() => {
    setDisplayValue(value)
  }, [reset])

  const handleOnBlur = () => {
    setShowingOptions(false);
  };

  const handleOnChange = (event, { value }) => {
    setHighlightOptionId(value);
  };
  
  return (
    <div>
      <FormInputLoader hide={!isLoading} />
      <Select
        highlightedOptionId={highlightOptionId}
        renderLabel={renderLabel}
        isShowingOptions={showingOptions}
        onRequestShowOptions={hanldeRequestShowOption}
        inputValue={displayValue}
        id={highlightOptionId}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        onInputChange={handleOnChange}
        onRequestHighlightOption={(event, { id }) => {
          setHighlightOptionId(id);
        }}
        onRequestSelectOption={(event, { id }) => {
          onChange(event,id)
          setDisplayValue(id);
          setShowingOptions((showingOptions) => !showingOptions);
        }}
        interaction={dropdownDataError ? "disabled" : "enabled"}
      >
        {TimeOptions.map((value) => (
          <Select.Option
            key={value}
            id={value}
            isSelected={value === highlightOptionId}
            isHighlighted={value === highlightOptionId}
          >
            {value}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default IasFormTimeInput;
